@if (model) {
    <div>
        @if (!isLoading) {
            <div>
                <control-linkable
                    #linkable
                    data-uiid="thirdpartyrisk-controllinkable"
                    typename="Controls"
                    displayValueProp="name"
                    [linked]="linked"
                    [unlinked]="unlinked"
                    [hideActions]="true"
                    [orderByValueProperty]="true"
                    (linkedChange)="linkedChanged($event)"
                    [disabled]="disabled"
                >
                </control-linkable>
            </div>
        } @else {
            <div>
                <div class="fancy-loader"></div>
            </div>
        }
    </div>
}
